<template>
  <div>
    <config-item v-for="(item, index) in menuConfigs" :config="item" :key="index"></config-item>
  </div>
</template>
<script>
import configItem from './config-item.vue';
export default {
  components: {configItem},
  props: {
    menuConfigs: [Array, Object, undefined],
    configData: Object,
    configs: Array,
    options: Object
  },
  provide() {
    return {
      configData: () => this.configData,
      mergedConfigData: () => this.mergedConfigData,
      configs: this.configs,
      options: this.options
    }
  },
  computed: {
    mergedConfigData() {
      const mergerData = {}
      this.configs.forEach(({name, defaultValue}) => {
        mergerData[name] = this.merge(defaultValue, this.configData[name])
      })
      return mergerData
    }
  },
  methods: {
    merge(defaultValue, newValue) {
      if (newValue === undefined || newValue === null) return defaultValue
      else if (Object.prototype.toString.call(defaultValue) === '[object Object]') {
        return {...defaultValue, ...newValue}
      } else if (Array.isArray(defaultValue)) return newValue
      return newValue
    }
  }
}
</script>